/**
 * Shënimet e versioneve — të dhëna, jo komponent.
 *
 * Deri tani kjo listë jetonte brenda `UpdatesModal.js`, mes 880 rreshtave kodi
 * pamjeje. Shtimi i një versioni do të thoshte të lëvizje nëpër atë skedar, të
 * gjeje fillimin e vargut, të zhvendosje flamurin `latest` nga hyrja e mëparshme
 * te e reja, dhe të përditësoje një numër versioni diku tjetër — katër ndryshime
 * të lidhura, secila e heshtur po të harrohej.
 *
 * Tani mbetet NJË: shto një objekt te fillimi i `RELEASES`.
 *
 *  · `latest` nuk shkruhet më — i pari te lista ËSHTË i fundit.
 *  · `CURRENT_VERSION` nuk shkruhet më — del nga i pari te lista.
 *  · `package.json` mbetet burimi i numrit; testi kontrollon që të përputhen,
 *    ndaj një version i ngritur pa shënime bie te testet, jo te përdoruesi me
 *    një dritare bosh.
 *
 * Forma e një hyrjeje:
 *   {
 *     version: 'v2026.09.12',
 *     label:   'Shtator 2026 · Titulli i shkurtër i lëshimit',
 *     sections: [
 *       { title: 'Moduli', entries: [{ type: 'new', text: '…' }] },
 *     ],
 *   }
 *
 * `type` merr: `new`, `improve`, `fix`, `security`.
 */

// ── Lëshimet — i pari është më i riu ─────────────────────────────────────────
export const RELEASES = [
  {
    version: 'v2026.10.11',
    label: 'Tetor 2026 · Numri i protokollit, filiali i punëtorit',
    sections: [
      {
        title: 'Kontratat',
        entries: [
          { type: 'new', text: 'Numri i protokollit për çdo kontratë — formati vendoset te Konfigurimi → Shabllonet → Kontratat (p.sh. 001/2026 ose FAR-0145/2026); në Word me {!contract_number!}' },
          { type: 'fix', text: 'Kontrata e shkarkuar ruhet me emrin e punëtorit (Kontrata_Emri_Mbiemri.pdf) dhe ka titullin e saj' },
          { type: 'improve', text: '«Shkarko» ofron Word ose PDF' },
          { type: 'fix', text: 'Ruajtja te «Kontratat» nuk fshin më numrin e protokollit apo kontratën e nënshkruar të ngarkuar' },
          { type: 'improve', text: 'Dritarja «Ndrysho» te «Kontratat» ka filialin, llojin e punës dhe pagën bazë ↔ për orë' },
        ],
      },
      {
        title: 'Punëtorët dhe pushimet',
        entries: [
          { type: 'fix', text: 'Filiali i punëtorit ruhet: «Të dhënat e punësimit» kanë fushën Filiali dhe departamentet e tij' },
          { type: 'fix', text: 'Pushimi që kalon Vitin e Ri ndahet: secili vit merr vetëm ditët e veta' },
        ],
      },
    ],
  },
  {
    version: 'v2026.10.10',
    label: 'Tetor 2026 · Kontratat nga Word me dizajnin e tyre, paga që llogaritet vetë',
    sections: [
      {
        title: 'Shabllonet e kontratave',
        entries: [
          { type: 'new', text: 'Ngarkoni kontratën tuaj nga Word dhe ajo mbetet ashtu siç është: shkronjat, tabelat, koka dhe nënshkrimet. Fushat si {!first_name!} ose {{emri}} lidhen vetë me të dhënat e punëtorit' },
          { type: 'new', text: 'Logoja e kompanisë merret nga profili: mjafton {!company_logo!} në dokument' },
          { type: 'new', text: 'Kontrata e punëtorit shkarkohet në Word ose PDF me dizajnin e shabllonit' },
          { type: 'fix', text: 'Editori i shablloneve nuk bllokohet më me mesazhin «domain not registered»' },
          { type: 'improve', text: '«Ndrysho template» ka të njëjtin dizajn dhe të njëjtat hapa si «Shto template»' },
          { type: 'fix', text: 'Datat, paga dhe departamenti dalin të formatuara në kontratë (05.01.2026, 1.200,00 €); numri personal dhe datëlindja nuk dalin më «--»' },
        ],
      },
      {
        title: 'Kontratat dhe paga',
        entries: [
          { type: 'new', text: 'Paga bazë ↔ paga për orë llogariten vetë (173,33 orë/muaj sipas LP Neni 20); fundjava dhe festa me shtesat e politikës fiskale' },
          { type: 'fix', text: '«Lloji i punës» te «Ndrysho kontratën» nuk shfaqet e zhduket më' },
        ],
      },
      {
        title: 'Pushimet',
        entries: [
          { type: 'new', text: '«Balanca e pushimeve»: zgjidhni me kutiza cilat lloje të shfaqen; «Të gjitha llojet» në një tabelë' },
          { type: 'improve', text: 'Ditët e lejuara sipas planit të kompanisë dhe Ligjit të Punës: në vit (vjetor, mjekësor), për rast (martesë, vdekje, lindje, dhurim gjaku), pa kufi (pa pagesë)' },
        ],
      },
      {
        title: 'Të tjera',
        entries: [
          { type: 'fix', text: 'Puna hibride: leja e re krijohet sërish (dilte «Ndodhi një gabim»)' },
          { type: 'fix', text: 'Kush ka të njëjtin email në dy kompani nuk del më nga llogaria çdo 30 minuta' },
          { type: 'new', text: 'Dosjet: skedari që s\'gjendet më në server shënohet qartë dhe ngarkohet sërish me një klik' },
        ],
      },
    ],
  },
  {
    version: 'v2026.10.9',
    label: 'Tetor 2026 · Balancat e pushimeve, departamentet dhe vendimet',
    sections: [
      {
        title: 'Raportet e pushimeve',
        entries: [
          { type: 'fix', text: '«Paga & Pushime», «Kartela e punëtorit» dhe «Pushimet (KS)» tregojnë të njëjtat balanca si «Balanca e pushimeve»: kërkesat e refuzuara dhe ato në pritje nuk numërohen më si të përdorura, as pushimet e viteve të tjera' },
          { type: 'fix', text: 'Pushimi mjekësor dhe llojet e tjera nuk zbresin më nga pushimi vjetor; emrat e llojeve janë ata të kompanisë suaj' },
          { type: 'new', text: '«Balanca e pushimeve» ka zgjedhjen e llojit të pushimit lart — vjetor, mjekësor, martesor, pa pagë dhe çdo lloj tjetër' },
          { type: 'fix', text: '«Pushimet (KS)» tregon vetëm punëtorët aktivë; pasivët janë një klikim larg te filtri i statusit' },
        ],
      },
      {
        title: 'Punëtorët dhe kontratat',
        entries: [
          { type: 'fix', text: 'Departamenti te «Të dhënat e punësimit» dhe departamenti, filiali e lloji i punës te «Ndrysho kontratën» kanë sërish opsionet e kompanisë' },
          { type: 'fix', text: '«Lloji i punës» ofron kohë të plotë / të pjesshme, jo politikat fiskale' },
        ],
      },
      {
        title: 'Kompania & Konfigurimi',
        entries: [
          { type: 'new', text: 'Një departament mund të jetë në disa filiale njëherësh (p.sh. Shitja në Prishtinë dhe në Gjakovë); format tregojnë departamentet e filialit të zgjedhur' },
          { type: 'new', text: 'Vendimet kanë lloje (ndërprerje, pushim, pagë, transferim, masë disiplinore, shpërblim) dhe secili shabllon gjenerohet si PDF për një punëtor' },
          { type: 'new', text: '«Struktura e PDF-së»: logoja, koka, qyteti, nënshkruesi, teksti përmbyllës dhe footer-i i vendimit — me parapamje' },
          { type: 'fix', text: 'Ngarkimi i kontratës pranon vetëm .docx, formatin që lexohet vërtet' },
        ],
      },
    ],
  },
  {
    version: 'v2026.10.8',
    label: 'Tetor 2026 · Kontratat nga formati juaj, ftesat që arrijnë',
    sections: [
      {
        title: 'Template-t e kontratave',
        entries: [
          { type: 'new', text: 'Importoni kontratën tuaj nga Word ashtu siç e keni: vijat bosh (____) gjenden vetë dhe lidhen me fushat — emri, numri personal, data e fillimit, paga, kompania. Ju vetëm i rishikoni dhe i konfirmoni' },
          { type: 'new', text: 'Dokumenti mund të tërhiqet drejt në faqe; emri i template-it merret nga emri i skedarit' },
          { type: 'improve', text: 'Formulari zyrtar i kontratës së punës (Ligji 03/L-212) njihet: 10 nga 20 vendet bosh lidhen vetë; ato pa të dhënë në sistem (puna provuese, gjykata, nënshkrimi) mbeten për dorë' },
          { type: 'improve', text: 'Faqja e template-it të ri: hapat janë një herë, editori majtas dhe fushat dinamike djathtas me kërkim, parapamja si faqe dokumenti' },
          { type: 'fix', text: 'Emri i template-it nuk humbet më ndërsa shkruhet — te krijimi dhe te editimi' },
        ],
      },
      {
        title: 'Ftesat dhe hyrja',
        entries: [
          { type: 'fix', text: 'Ftesat arrijnë sërish në Gmail dhe Outlook — më parë refuzoheshin si email i paverifikuar' },
          { type: 'fix', text: 'Linku i ftesës punon për çdo kompani. Te kompanitë me bazë të vetën dilte «i skaduar ose i pavlefshëm» edhe kur ishte i ri; edhe ftesat e dërguara më parë tani funksionojnë' },
          { type: 'fix', text: 'Kur i njëjti email ka llogari në disa kompani, hyrja pyet «Zgjidhni kompaninë» — më parë dilte «Email ose fjalëkalim i gabuar» edhe me fjalëkalimin e saktë' },
          { type: 'fix', text: '«Harrove fjalëkalimin?» dërgon linkun nga posta e Nexuma-s dhe nuk jep më gabim kur posta e kompanisë s\'është e konfiguruar mirë' },
          { type: 'new', text: 'Emaili i ftesës dhe i rivendosjes u ridizajnuan: butoni, linku rezervë dhe data e skadimit e shkruar plotë' },
          { type: 'improve', text: 'Faqja «Aktivizo llogarinë» tregon llogarinë që aktivizohet dhe kërkesat e fjalëkalimit; kur linku s\'vlen, thotë pse dhe çfarë të bëhet' },
          { type: 'fix', text: 'Ridërgimi i ftesës nuk e prish më linkun e mëparshëm — çdo email i dërguar hap të njëjtin link sa kohë vlen' },
        ],
      },
      {
        title: 'Përdoruesit',
        entries: [
          { type: 'new', text: 'Butoni «Ridërgo ftesën» te çdo përdorues që s\'ka hyrë ende — ftesa shkon me email, pa hapur detajet' },
          { type: 'new', text: 'Një përdorues që s\'ka hyrë kurrë mund të fshihet (p.sh. ftesë te adresa e gabuar). Kush ka hyrë ose ka të dhëna në histori çaktivizohet, nuk fshihet' },
        ],
      },
      {
        title: 'Rekrutimi dhe faqja publike',
        entries: [
          { type: 'improve', text: 'Historiku i rekrutimit punon në telefon: çdo aplikim bëhet kartë dhe filtrat rrinë në dy kolona' },
          { type: 'improve', text: 'Faqja publike: kalkulatori i çmimit nga 1 deri në 100+ punonjës, pamje më kompakte në telefon dhe tekst me kontrast më të lartë' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.12',
    label: 'Shtator 2026 · Rekrutimi nga konkursi te punësimi',
    sections: [
      {
        title: 'Rekrutimi',
        entries: [
          { type: 'new', text: 'Zinxhiri i plotë: Pozitat → Kandidatët → Intervistat → Ofertat → Punësimet → Historiku. Secili hap ka faqen e vet, dhe kandidati kalon prej njërit te tjetri pa u shkruar dy herë' },
          { type: 'new', text: 'Intervistat janë regjistrime me radhë, pjesëmarrës dhe vlerësim — jo një fjalë te statusi. Ofertat kanë pagën, datën e fillimit, afatin e përgjigjes dhe dokumentin që printohet' },
          { type: 'new', text: 'Punësimet: kush u punësua, nga cila pozitë, me cilën ofertë, nga cili rekrutues — dhe a është lidhur me Stafin. Nuk krijon punonjës vetvetiu' },
          { type: 'new', text: 'Historiku i rekrutimit gjen këdo që ka aplikuar më parë, edhe te pozitat e mbyllura, dhe i bashkon aplikimet e të njëjtit person kur emaili përputhet' },
          { type: 'new', text: 'Veprime mbi shumë kandidatë njëherësh: cakto rekrutuesin, kalo fazën, refuzo. Ofrohen vetëm fazat që janë hap i ligjshëm për të gjithë të zgjedhurit' },
          { type: 'new', text: 'Pozita mban numrin e vendeve dhe kriteret; prej tyre gjen kandidatë ekzistues dhe i fton për pozitën e re — ftesë, jo ofertë, dhe aplikimi i vjetër nuk preket kurrë' },
          { type: 'improve', text: 'Refuzimi kërkon arsye nga një listë e mbyllur, ndaj raporti i refuzimeve ka përgjigje, jo një kolonë të zbrazët' },
          { type: 'improve', text: 'Lista e kandidatëve lexon një faqe nga serveri, jo çdo aplikim; numëruesit maten mbi të gjithë të filtruarit, jo mbi faqen që shihet' },
          { type: 'improve', text: 'Burimi i kandidatit u bë fjalor: «LinkedIn», «linkedin» dhe «LI» nuk janë më tre rreshta të ndryshëm te raporti' },
          { type: 'security', text: 'Historia e një aplikimi shkruhet vetëm nga serveri — deri tani mund të rishkruhej nga kushdo që dërgonte një trup të ndryshuar' },
          { type: 'fix', text: 'Lista e pozitave nuk tërheq më banner-in e figurës: ishte 720 KB për gjashtë konkurse, që nuk shiheshin askund' },
        ],
      },
      {
        title: 'Projektet',
        entries: [
          { type: 'new', text: 'Tab-i «Aktiviteti» tregon afatin, ditët e mbetura dhe orët e planifikuara për secilin — nga caktimet dhe nga orari i punës, të ndara sepse janë dy burime të ndryshme' },
          { type: 'new', text: 'Raporti i kohës del në Excel, shkarkohet si PDF ose hapet për printim — nga e njëjta faqosje si raportet e tjera' },
          { type: 'new', text: 'Klienti i ri shtohet drejt nga formulari i projektit, pa humbur çka ke shkruar; faqja «Klientët» u kthye te menyja për detajet' },
          { type: 'improve', text: 'Një projekt pa departament ose menaxher e thotë vetë çfarë i mungon dhe çon te forma, në vend që të tregojë tetë viza' },
          { type: 'fix', text: 'Datat te projektet shfaqen si 05.08.2026, jo 2026-08-05 — si te pjesa tjetër e sistemit' },
        ],
      },
      {
        title: 'Vërejtjet dhe trajnimet',
        entries: [
          { type: 'fix', text: 'Një vërejtje e krijuar nuk shfaqet më dy herë te lista' },
          { type: 'fix', text: '«Ruaj dhe dërgo» e thotë kur punëtori s\'ka email të regjistruar, në vend që të raportojë sukses pa dërguar asgjë' },
          { type: 'improve', text: 'Punëtori kërkohet edhe me email, jo vetëm me emër — kur dy njerëz e kanë të njëjtin emër, adresa i dallon' },
          { type: 'improve', text: 'Trajnimet: tabelë e qëndrueshme, data me numra, dhe detajet hapen pa u prerë nga koka e faqes' },
        ],
      },
      {
        title: 'Sistemi',
        entries: [
          { type: 'fix', text: 'Kjo dritare hapet një herë për version dhe e mban mend te llogaria jote — jo te shfletuesi. Pastrimi i cache-ve, dritarja private ose një kompjuter tjetër nuk e sjellin më përsëri' },
          { type: 'fix', text: 'PDF-ja e raporteve del edhe kur shfletuesi bllokon dritaret kërcyese: dokumenti hapet gjithsesi, në vend që butoni të dukej se nuk punon' },
          { type: 'fix', text: 'Posta nga Nexuma del sërish: dërgimi kalon nga llogaria e vërtetuar e platformës, dhe arsyeja e një dështimi thuhet hapur' },
          { type: 'improve', text: 'Organigrami u rivizatua — çdo degë njihet nga ngjyra e departamentit dhe vijat lidhin vërtet kartat' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.11',
    label: 'Shtator 2026 · Organigrami që rregullohet me dorë',
    sections: [
      {
        title: 'Organigrami',
        entries: [
          { type: 'new', text: 'Strukturën e rregullon vetë: shtyp «Rregullo strukturën» dhe tërhiq një person mbi eprorin e tij — lëshoje mbi emrin e kompanisë që të mbetet pa epror' },
          { type: 'improve', text: 'Pamje e re: çdo degë njihet nga ngjyra e departamentit, ekipi zbret në kolonë si te pemët e dosjeve, dhe degët paketohen pa lënë hapësirë boshe' },
          { type: 'fix', text: 'Vijat lidhëse tani lidhin vërtet kartat — më parë ishin vija të gjata që qëndronin varur mes tyre' },
          { type: 'fix', text: 'Departamenti nuk përsëritet te çdo vartës i të njëjtit ekip' },
        ],
      },
      {
        title: 'Posta dhe cilësimet',
        entries: [
          { type: 'fix', text: 'Një email që nuk del nuk e prish më veprimin: vendimi i pagës ruhet, njoftimi i mungesës riprovohet, dhe arsyeja thuhet hapur' },
          { type: 'improve', text: 'Kredencialet SMTP u hoqën nga profili i kompanisë — postën e dërgon Nexuma; aty mbetën vetëm adresat ku shkojnë njoftimet e prezencës' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.10',
    label: 'Shtator 2026 · Kërkesat e klientit, orët e sakta, llogaritë e sigurta',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Punëtori ka tani dy email-e — personalin dhe atë të kompanisë — dhe ti zgjedh se te cili shkojnë njoftimet' },
          { type: 'new', text: 'Xhirollogaritë mbahen si histori: kur punëtori ndërron bankën, e vjetra nuk fshihet — çaktivizohet, dhe paga shkon te ajo që është aktive' },
          { type: 'new', text: 'Orari mujor individual hapet drejt me një punëtor, me rrjetë 10-minutëshe dhe orët sipas llojit të punës për muajin dhe javë për javë' },
          { type: 'new', text: 'Te «Plani i Punës», klikimi mbi një projekt hap «Orët» e atij projekti' },
          { type: 'new', text: 'Te Dosjet, butoni «Shiko» hap dokumentin brenda aplikacionit — PDF-të dhe fotot nuk shkarkohen më vetëm për t\'i parë' },
          { type: 'new', text: 'Përqindjet te orët e projektit: sa % e planit u punua, sa pauzë, dhe çdo lloj pushimi si % e ditëve të punës' },
          { type: 'new', text: 'Ndërtuesi i roleve i mbulon tani të gjitha modulet, dhe pozitat marrin fushëveprim: veta · ekipi · departamenti · kompania' },
        ],
      },
      {
        title: 'Orët dhe pagat',
        entries: [
          { type: 'fix', text: '«Overtime Hours Accumulated» mblidhet vetvetiu nga orari dhe shpenzohet si ditë pushimi' },
          { type: 'fix', text: 'Orët e punuara jashtë orarit nuk humbin më nga totali, dhe pauza nuk zbritet dy herë' },
          { type: 'fix', text: 'Një ditë e mbyllur pa dalje nuk numërohet më si e punuar deri te ora e tanishme' },
          { type: 'fix', text: 'Puna në ditë pushimi numërohet, me pilulën e vet' },
          { type: 'fix', text: 'Pagat llogariten me shkallët e tatimit në fuqi (0–250 € 0% · 250–450 € 8% · mbi 450 € 10%), pa sigurim shëndetësor që nuk mbahet' },
          { type: 'fix', text: 'Bilanci i pushimeve pas një rregullimi tregon sërish lejen vjetore, jo vetëm ditët e rregulluara' },
          { type: 'fix', text: 'Importi i aseteve i ruan vërtet rreshtat, dhe thotë hapur sa u importuan e cilat dështuan' },
        ],
      },
      {
        title: 'Siguri',
        entries: [
          { type: 'security', text: 'Email-i i një llogarie ndryshohet vetëm nga administratori, ose nga vetë pronari' },
          { type: 'security', text: 'Vetëm administratori cakton role administratori — regjistrimi nuk krijon më admin si parazgjedhje' },
          { type: 'security', text: 'Administratori i fundit aktiv nuk çaktivizohet dot' },
          { type: 'security', text: 'Krijimi, ndryshimi dhe çaktivizimi i llogarive shkruhen te Audit Log' },
          { type: 'security', text: 'Pamja e orareve kërkon leje dhe secili sheh vetëm ekipin e vet' },
          { type: 'security', text: 'Privilegjet e dhëna te «Përdoruesit» zbatohen vërtet — deri tani ruheshin dhe nuk kishin efekt' },
        ],
      },
      {
        title: 'Sesioni',
        entries: [
          { type: 'fix', text: 'Aplikacioni nuk të nxjerr më nga llogaria në mes të punës: një ndërprerje interneti, një ristartim serveri ose një kufi kërkesash nuk e mbyllin sesionin' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.9',
    label: 'Shtator 2026 · Orët, plani që duket',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Te «Plani i Punës → Orët» zgjedh disa punëtorë dhe një interval duke mbajtur majtasin dhe duke tërhequr mbi rrjetë, si te Excel-i — dhe forma e caktimit hapet me orët e tërhequra të mbushura' },
          { type: 'new', text: 'Filtri i periudhës: ditë · javë · muaj · 3 muaj, me përmbledhje për secilin punëtor dhe kalim te raporti i ditës' },
          { type: 'new', text: 'Eksport në Excel i pamjes së Orëve: orët sipas llojit të punës, orët e pauzave, vonesat dhe mungesat — një rresht për punëtor' },
          { type: 'new', text: 'Brenda një orari mund të caktohen disa lloje pune dhe projekte për intervale të ndryshme të së njëjtës ditë' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'fix', text: 'Pauza e planifikuar nuk numërohet më si mungesë: kush dilte te ora dhe hynte prapë te ora merrte «Mungesë» për orën që vetë kompania ia kishte caktuar' },
          { type: 'fix', text: 'Pauza nuk zbritet më dy herë nga orët e punuara — numri i orëve neto ishte më i vogël se sa duhej' },
          { type: 'fix', text: 'Faqja e re mbërrin te shfletuesi pas çdo përditësimi: deri tani memoria e vjetër mbetej dhe ekrani tregonte versionin e kaluar' },
          { type: 'improve', text: 'Nuk planifikohet dot mbi një pushim të aprovuar — caktimi ndalet dhe e thotë pse' },
          { type: 'improve', text: 'Pauza e shkurtër dhe ajo e gjatë kanë simbolin e vet dhe përkthehen në shqip, anglisht e gjermanisht' },
          { type: 'improve', text: 'Ngjyrat e rrjetës ndjekin llojin e punës nga planifikimi; vetëm përjashtimi bie në sy, jo norma' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.8',
    label: 'Shtator 2026 · verifikimi para krijimit',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'security', text: 'Kompania nuk krijohet më kur dorëzohet formulari, por kur klikohet linku që të vjen me email — pra një adresë e shkruar gabim, ose e dikujt tjetër, nuk lë pas vetes asnjë bazë të dhënash' },
          { type: 'new', text: 'Linku i verifikimit vlen 24 orë dhe konsumohet me përdorimin e parë; pas tij kredencialet të vijnë me email nga Nexuma' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Nëse e plotëson formularin sërish para se ta kesh verifikuar, të dërgohet një link i ri — pa u krijuar kërkesë e dytë dhe pa u ndryshuar identifikuesi i kompanisë' },
          { type: 'improve', text: 'Ekrani e thotë qartë se çfarë pret: linku, afati i tij, dhe fakti që deri në klikim nuk është hapur asgjë' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.7',
    label: 'Shtator 2026 · konfirmimi i email-it',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'security', text: 'Hapja e kompanisë kërkon konfirmimin e adresës: llogaria krijohet e mbyllur dhe hapet vetëm kur klikohet linku që vjen me email — kështu askush nuk hap dot kompani me adresën e dikujt tjetër' },
          { type: 'new', text: 'Linku i konfirmimit vlen një herë të vetme dhe zëvendësohet sa herë ri-dërgohet, që një email i vjetër të mos mbetet çelës i përhershëm' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Ekrani i kyçjes e njeh kthimin nga linku dhe të thotë nëse konfirmimi u krye, ishte i pavlefshëm, ose ishte përdorur më parë' },
          { type: 'improve', text: 'Nëse posta nuk punon, regjistrimi ndalet me një mesazh të qartë në vend që të hapë një kompani te e cila askush nuk hyn dot' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.6',
    label: 'Shtator 2026 · hapja e kompanisë, e ndrequr',
    sections: [
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'fix', text: 'Identifikuesi i kompanisë nuk shpiket më nga sistemi: një emër i zënë refuzohet dhe të kërkohet një tjetër, në vend që të merrje pa e ditur një adresë me shkronja të rastësishme në fund' },
          { type: 'fix', text: 'Nëse hapja dështon dhe e plotëson formularin sërish, provohet e njëjta kërkesë — jo një e dytë. Fjalëkalimi merret nga dorëzimi i fundit, ai që mban mend' },
          { type: 'fix', text: 'Numri i telefonit njihet edhe kur shkruhet ndryshe — «+383 49 777 300» dhe «049 777 300» janë i njëjti numër, ndaj e njëjta kompani nuk hapet dy herë me dy adresa email' },
          { type: 'improve', text: 'Kur email-i i konfirmimit nuk del, ekrani e thotë hapur dhe i tregon të dhënat e kyçjes aty — në vend që të presësh një mesazh që nuk ka nisur kurrë' },
          { type: 'fix', text: 'Faqja e re nuk ngec më pas një përditësimi: emri i memories së shfletuesit ndryshon me çdo version' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.5',
    label: 'Shtator 2026 · hapja e kompanisë',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Kompania hapet në çast: plotëso formularin dhe kyçu menjëherë me email-in e fjalëkalimin që sapo zgjodhe — pa pritur që dikush ta aprovojë kërkesën dhe pa e hapur bazën dikush me dorë' },
          { type: 'new', text: 'Çdo kompani e re nis me demo 5-ditore, e njëjta nga çdo buton. Afati shkruhet te email-i i mirëseardhjes, shihet te lista e kërkesave, dhe ndalet vetë kur mbaron' },
          { type: 'new', text: 'Pas hapjes, butoni «Kyçu tani» të çon te forma e kyçjes me email-in tashmë të mbushur — nuk ka çfarë të pritet e as të kopjohet' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Formulari i hapjes i kërkon të gjitha të dhënat — qytet, telefon, adresë dhe person kontaktues. Një kompani pa to është një klient që nuk kontaktohet dot kur demo-ja mbaron' },
          { type: 'fix', text: 'Identifikuesi i kompanisë dilte «i zënë» për çdo emër që shkruaje: kontrolli bëhej te një rrugë që kërkon kyçje, kurse formulari shfaqet pikërisht para kyçjes' },
          { type: 'fix', text: 'Kur posta nuk punonte, kërkesa për kompani të re nuk vonohej — bllokohej pa e ditur askush, sepse linku i aprovimit jetonte vetëm te ai email. Tani hapja nuk varet fare nga posta; email-i është vetëm njoftim' },
          { type: 'fix', text: 'Aprovimi e krijonte adminin te baza e përbashkët, jo te baza e kompanisë së re — pra «sistemi juaj u aktivizua» ishte i pavërtetë derisa dikush ta hapte bazën veçmas' },
          { type: 'security', text: 'Një adresë që ka tashmë llogari nuk hap dot kompani të re: përndryshe kyçja e atij njeriu do të dërgohej te baza e re dhe ai nuk do të hynte më te e vetja' },
          { type: 'security', text: 'Afati i aksesit kontrollohej vetëm te kyçja, ndaj një sesion i hapur vazhdonte të punonte deri një javë pas skadimit. Tani kontrollohet te çdo kërkesë dhe te rifreskimi i sesionit' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.4',
    label: 'Shtator 2026 · importi i aseteve',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Importo asete nga Excel ose CSV: lista që ke nga më parë hyn ashtu siç është — kolonat njihen vetvetiu edhe kur janë anglisht ("Item", "Serial No", "Assigned to"), dhe i konfirmon në një hap' },
          { type: 'new', text: 'Kolona "Mbajtësi aktual" e regjistron pajisjen te punonjësi që e mban vërtet: hapet dorëzimi me datë dhe historiku që e provon, në vend që tërë inventari të hyjë sikur rri në depo' },
          { type: 'new', text: 'Shabllon i gatshëm me tri fleta — të dhënat me tre rreshta shembull, udhëzimet për çdo kolonë, dhe listat e vlerave me emrat e departamenteve e të punonjësve që ekzistojnë te sistemi' },
          { type: 'new', text: 'Fotot e pajisjeve (opsionale): shkruaj emrin e skedarit te fleta, zgjidh fotot te importi dhe ato ngarkohen vetë te aseti përkatës' },
          { type: 'new', text: 'Para importit sheh çdo rresht: cilët hyjnë, cilët hyjnë me vërejtje dhe cilët jo — dhe rreshtat me problem shkarkohen si fletë më vete, me arsyen përbri' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Statuset dhe gjendjet lexohen në disa gjuhë e trajta: "In use", "Në depo", "Repair", "Sold", "Neu" — dhe shumat si "1.250,50 €" ose datat në tri formate brenda së njëjtës kolonë' },
          { type: 'improve', text: 'Një pajisje e regjistruar dy herë nuk hyn dy herë: seria, kodi i inventarit dhe kodi i asetit kontrollohen para dërgimit dhe sërish te serveri — ri-ngarkimi i së njëjtës fletë mbaron me "ekzistonin", jo me gabime' },
          { type: 'improve', text: 'Fotot zvogëlohen te shfletuesi para se të nisen dhe ngarkohen një nga një — njëqind foto nga telefoni nuk e mbytin më lidhjen as serverin' },
          { type: 'fix', text: 'Specifikimet me emra që përsëriten mes kategorive (p.sh. "Storage / SSD" te laptopi dhe "Memoria" te telefoni) ruheshin si fusha të reja dhe dilnin dy herë te kartela e asetit' },
          { type: 'fix', text: 'Pa internet dilte faqja e shfletuesit — "You\'re offline", anglisht, me një ikonë të huaj. Tani del faqja e Nexuma-s me logon dhe me shpjegimin shqip, dhe rifreskohet vetë sapo lidhja kthehet' },
          { type: 'improve', text: 'Kur rrjeti bie ndërsa je duke punuar, aplikacioni e thotë njëherë e qartë — "Nuk ke lidhje interneti, ndryshimet nuk ruhen derisa lidhja të kthehet" — në vend që çdo ekran të ankohej veç' },
          { type: 'improve', text: 'Serveri i papërgjigjshëm nuk e nxjerr më faqen bosh të serverit: shfaqet kopja e fundit e faqes, ose ekrani ynë i mungesës së lidhjes' },
          { type: 'fix', text: 'Ikona e aplikacionit rifreskohet te shfletuesi dhe te aplikacioni i instaluar — disa pajisje mbanin ende ikonën e vjetër' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.3',
    label: 'Shtator 2026 · importi i stafit',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Importo staf nga Excel ose CSV: ngarko listën që ke nga sistemi i mëparshëm, kolonat njihen vetvetiu dhe i konfirmon në një hap — nuk ka nevojë ta rishkruash fletën' },
          { type: 'new', text: 'Shabllon i gatshëm për shkarkim me 40 kolona në 11 grupe, dy rreshta shembull dhe emrat e departamenteve e degëve që ekzistojnë vërtet te sistemi' },
          { type: 'new', text: 'Para importit sheh çdo rresht: cilët hyjnë, cilët hyjnë me vërejtje dhe cilët jo — dhe rreshtat me problem shkarkohen si fletë më vete, me arsyen përbri' },
          { type: 'new', text: 'Importi krijon edhe kontratën e parë dhe bilancin hapës të pushimeve, nëse fleta i ka ato kolona' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Krijimi i punëtorit ka një derë të vetme: butoni "Shto Punëtor" çon te forma e plotë, ajo me kontratën dhe caktimin te projekti në të njëjtin hap. Më parë butoni kryesor çonte te forma e shkurtër' },
          { type: 'fix', text: 'Punëtori i regjistruar nga forma e re dilte pa asnjë vendim për prezencën — mungonin e drejta kryesore dhe kanalet. Tani ka të njëjtin seksion si te profili' },
          { type: 'improve', text: '"Regjistrimi i Prezencës" u bë më i mbledhur: tri kanalet rrinë krah për krah me hollësitë brenda secilit, në vend të nëntë rreshtave njëri nën tjetrin' },
          { type: 'improve', text: 'Butoni "Vërejtje" u hoq nga koka e listës së punëtorëve — moduli mbetet te menuja anësore, bashkë me regjistrin e vet' },
          { type: 'fix', text: 'Përditësimet e bazës së të dhënave zbatoheshin vetëm te sistemi qendror dhe kurrë te bazat e kompanive të veçanta — një kompani e hapur më herët mund të mbetej pa tabelat e reja. Tani çdo bazë përditësohet, dhe secila raportohet veç' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.2',
    label: 'Shtator 2026 · mosha dhe njoftimet',
    sections: [
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Te informatat e punëtorit datëlindja shoqërohet nga mosha e sotme — e llogaritur sa herë hapet, dhe që rritet në ditëlindje, jo më 1 janar' },
          { type: 'fix', text: 'Te "Profili im" datëlindja ishte gjithmonë bosh: lexohej me një emër fushe që API-ja nuk e kthen kurrë' },
          { type: 'fix', text: 'Njoftimi i përditësimit dilte i ngjitur mbi menunë anësore në vend që të rrinte në qendër' },
        ],
      },
    ],
  },
  {
    version: 'v2026.09.1',
    label: 'Shtator 2026 · asetet dhe prezenca',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Regjistri i aseteve: pajisjet e kompanisë, dorëzimi dhe kthimi te punëtori, dosja e secilit aset dhe faqja "Asetet e mia"' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Faqja "Hyrje / Dalje" u rifreskua: kartelat e statuseve filtrojnë vetë listën, dhe lista ka faqen e vet' },
          { type: 'improve', text: 'Ekrani i murit "/monitoring" u rindërtua — kartela statusesh, prezenca e ditës, trendi shtatëditor dhe gjendja e kioskave, në pamjen e zakonshme të aplikacionit' },
        ],
      },
    ],
  },
  {
    version: 'v2026.08.4',
    label: 'Gusht 2026 · rregullime',
    sections: [
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'fix', text: 'Adresat e politikës së privatësisë dhe të kushteve të përdorimit hapeshin te faqja e kyçjes në vend të tekstit — tani çojnë aty ku duhet, nga çdo formë e lidhjes' },
          { type: 'improve', text: 'Politika dhe kushtet hapen si lidhje të vërteta te fundi i faqes: kopjohen, hapen në tab të ri dhe ndahen me dikë tjetër' },
          { type: 'improve', text: '"Regjistrimi i Prezencës" tani është edhe te formulari i punëtorit të ri — më parë kanalet caktoheshin vetëm pasi punëtori ishte krijuar' },
          { type: 'improve', text: 'Statuset lexohen si familje: tri gjendjet "Në pritje" te ndryshimet e punësimit kishin ngjyra të ndryshme dhe nuk dukeshin si e njëjta gjë' },
          { type: 'improve', text: '"Neto/Bruto" te punëtori nuk ngjyroset më sikur njëra të ishte më e mirë se tjetra — është lloj, jo vlerësim' },
          { type: 'improve', text: 'Eksportet PDF kanë një theks të vetëm në vend të tetë ngjyrave të ndryshme për të njëjtin numërues' },
        ],
      },
    ],
  },
  {
    version: 'v2026.08.3',
    label: 'Gusht 2026 · pushimet dhe prezenca',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Bashkëngjitja te rregullimi i ditëve të pushimit — vendimi që e justifikon ndryshimin ruhet bashkë me atë ndryshim të caktuar, jo thjesht te dosja e punonjësit' },
          { type: 'new', text: '"Historiku i ndryshimeve" e hap dëshminë aty ku lexohet arsyeja — data, ndryshimi, balanca para e pas, arsyeja dhe kush e bëri, në një rresht' },
          { type: 'new', text: '"Regjistrimi i Prezencës" te profili i punëtorit — një çelës kryesor plus kanalet e lejuara: Kiosk/QR, Web dhe Aplikacioni mobil' },
          { type: 'new', text: 'Pushimi i lehonisë me tri etapa — Kompania · Shteti · Pa pagesë — brenda NJË kërkese të vetme, me periudhën totale dhe statusin e secilës etapë' },
          { type: 'new', text: 'Etapat e lehonisë zhvendosen kur lindja vjen më herët, pa u fshirë kërkesa dhe pa u krijuar një e dytë' },
          { type: 'new', text: 'Filtri "Të gjitha" te kolonat e Balancës së pushimeve — një klikim në vend të katërmbëdhjetëve' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Check-in/Check-out nuk kushtëzohet më nga orari i punës — kush vjen 07:50 për turnin 08:00 e regjistron orën e vet të vërtetë, në vend që të mbetet te dera' },
          { type: 'improve', text: 'Orari mbetet i plotë për vonesat, krahasimin plan–realitet dhe raportet — thjesht nuk vendos më kush lejohet të regjistrojë prezencë' },
          { type: 'improve', text: 'Cilësimet e prezencës u bashkuan në një kartelë të vetme — më parë ishin tri kuti që thoshin gati të njëjtën gjë' },
          { type: 'improve', text: 'Statuset e regjistrit të rregullimeve përdorin fjalorin e përbashkët; një rregullim i kthyer nuk shfaqet më i kuq, sepse korrigjimi nuk është gabim' },
          { type: 'improve', text: 'Zgjedhësi i punonjësit — "Të gjithë" është tani zgjedhje e vërtetë, jo tekst gri i pjerrët, dhe lista nxë tetë emra pa e prerë të fundit' },
          { type: 'fix', text: 'Filtrat te "Rregullimet e pushimeve" dilnin secili sa tërë gjerësia, një për rresht — tani janë një shirit i vetëm' },
          { type: 'fix', text: 'Punëtori pa departament merrte ngjyrën e departamentit të parë; tani lexohet si mungesë' },
        ],
      },
      {
        title: 'Siguri',
        entries: [
          { type: 'security', text: 'Kanali i regjistrimit zbatohet te serveri, jo vetëm te butoni — një kanal i fikur nuk anashkalohet dot as duke e thirrur API-n drejtpërdrejt' },
          { type: 'security', text: 'Punonjësi nuk i ndryshon dot vetes kanalet e prezencës; kërkohet e drejta e menaxhimit' },
          { type: 'security', text: 'Bashkëngjitja e një rregullimi shkarkohet vetëm nga ata që kanë të drejtë ta lexojnë regjistrin' },
        ],
      },
    ],
  },
  {
    version: 'v2026.08.2',
    label: 'Gusht 2026 · përditësim',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Rregullimet e pagës — bonuset, avancet, rimbursimet dhe ndalesat në një regjistër të vetëm, me proces të vërtetë: kërkesë → dërgim për aprovim → vendim' },
          { type: 'new', text: '"Rregullimet e mia" — punonjësi sheh kërkesat e veta dhe vendimin bashkë me arsyen; refuzimi pa arsye nuk lejohet më' },
          { type: 'new', text: 'Avanci i pagës si regjistër më vete — kthimi i avancit e ul vetë bilancin, pa u mbajtur me dorë' },
          { type: 'new', text: '"Lista e Pagave" — formulari zyrtar i Kosovës si eksport: regjistri që dorëzohet dhe nënshkruhet, jo përmbledhja e ekranit' },
          { type: 'new', text: 'Shabllonet e vërejtjeve dhe të vendimeve të ndërprerjes — i njëjti rast nuk shkruhet nga e para çdo herë' },
          { type: 'new', text: 'Biblioteka e dokumenteve — Rregullore · Politika · Procedura · Njohuri nisen me 24 dokumente model, të shënuara qartë si SHEMBUJ' },
          { type: 'new', text: 'Bisedat — grupe private (jo vetëm kanale të gjithë firmës), njoftime push, fotoja e profilit dhe dërgimi i fotove' },
          { type: 'new', text: 'Raportimi dhe bllokimi te bisedat, me radhë shqyrtimi për menaxhmentin dhe faqen e kushteve të përdorimit' },
          { type: 'new', text: 'Mbyllja e listës së pagave — "Proceso pagat" e mbyll listën; pas saj rreshtat nuk ndryshohen dot pa e rihapur me leje' },
          { type: 'new', text: 'Te punëtori u shtuan punësimi i dytë, statusi i rezidencës dhe paga e dakorduar bruto apo neto — fusha që i kërkon llogaritja dhe formulari zyrtar' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Raportet — të gjitha me të njëjtin shirit filtrash, kuti shifrash dhe butona eksporti; më parë secili raport e ndërtonte vetë të vetin' },
          { type: 'improve', text: 'Vërejtjet — Excel, PDF, CSV dhe printimi dalin nga e njëjta listë kolonash; më parë secili eksport i mbante kolonat e veta' },
          { type: 'improve', text: 'Konfirmimet shfaqen brenda app-it, me temën e tij — jo kutia e browser-it me kokën "localhost says"' },
          { type: 'improve', text: 'Rolet e personalizuara — dialogu i krijimit ekzistonte, por asnjë buton nuk e hapte' },
          { type: 'fix', text: 'Pagat nuk ruheshin fare në prodhim — mungonin dy kolona të sigurimit shëndetësor, dhe ekrani tregonte "Ndodhi një gabim" në vend të shkakut' },
          { type: 'fix', text: '"Proceso pagat" kthente "Lista është bosh" — mbyllja nisej para se rreshtat të mbërrinin te serveri' },
          { type: 'fix', text: '"Puna Hibride" jepte gabim 500 — tabela e lejeve nuk krijohej kurrë, vetëm ndryshohej' },
          { type: 'fix', text: 'Faqe e bardhë pas një lëshimi të ri — app-i mbante përgjithmonë një kopje të vjetër në kujtesë' },
          { type: 'fix', text: 'Njoftimi i versionit dilte dy herë, në dy stile e dy cepa — tani një i vetëm' },
          { type: 'fix', text: 'Migrimet e bazës aplikoheshin me dorë dhe askush nuk mbante shënim se cili ishte zbatuar — tani zbatohen vetë në nisje dhe historia ruhet' },
          { type: 'fix', text: 'Adresat e kontaktit te kushtet dhe politika e privatësisë ishin të pavlefshme — tani support@nexuma.app' },
          { type: 'security', text: 'Rregullimet e pagës ishin të aprovueshme nga kushdo i kyçur — një "aprovuar" i vënë vetes hynte drejt te paga; tani vendos vetëm shqyrtuesi, dhe askush për rreshtin e vet' },
          { type: 'security', text: 'Pesë rrugë e trajtonin kyçjen si autorizim: orët shtesë aprovoheshin nga vetë punëtori, dhe dosja e punësimit — kontratat, certifikatat, CV-të — lexohej e fshihej duke ndërruar numrin te adresa' },
        ],
      },
    ],
  },
  {
    version: 'v2026.08.1',
    label: 'Gusht 2026 · përditësim',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Komunikimi — kanale dhe mesazhe direkte brenda app-it, të njëjtat biseda si te Nexuma Mobile; të palexuarat shfaqen te koka' },
          { type: 'new', text: 'Vlerësimet e ekipit — eprori shkruan vlerësimin që punonjësi e lexon te "Vlerësimi im"; timlideri sheh vetëm vartësit e vet' },
          { type: 'new', text: 'Leja e lehonisë — kërkohet si lloj pushimi, me periudhat 6+3+3 të llogaritura (70% punëdhënësi · 50% qeveria · pa pagesë) dhe datën e mbarimit të plotësuar vetë' },
          { type: 'new', text: 'Lehonia në dy faza — para lindjes (raporti i shtatzënisë) dhe pas lindjes (certifikata e lindjes); dokumenti ruhet te dosja e punonjëses' },
          { type: 'new', text: 'Balanca e pushimeve — eksport i plotë në Excel: 29 kolona, përmbledhje sipas departamentit, mospërputhjet dhe shpjegimi i formulave' },
          { type: 'new', text: 'Llojet e pushimit u shtuan: leja e atësisë, vdekja në familje dhe lëndimi në punë' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Zgjedhësi i punonjësit u bë me kërkim kudo — shkruaj mbiemrin ose pjesë të emrit, pa shkronjat ë/ç nëse do' },
          { type: 'improve', text: 'Balanca e pushimeve — pamje më kompakte: veglat në një rresht, përmbledhja lart, kolona e emrit dhe totali të ngjitur' },
          { type: 'improve', text: 'Kërkesa e re për pushim — gabimet dalin ndërsa shkruan, jo pas dërgimit; kalendari nuk ofron data të pamundura' },
          { type: 'improve', text: 'Filtri i datave te "Kërkesat dhe Aprovimet" hapet me vitin kalendarik, jo me muajin' },
          { type: 'fix', text: 'Tejkalimi i balancës llogaritej pa ditët e bartura nga viti i kaluar, bonusin e vjetërsisë dhe korrigjimet e HR-së — tani merret shifra e vërtetë nga serveri' },
          { type: 'fix', text: 'Numrat e llojeve të pushimit nuk përputheshin me bazën: një kërkesë "martesor" ruhej me numrin e lehonisë' },
          { type: 'fix', text: 'Kërkesa nga kalendari ruhej me 0 ditë; tani ditët llogariten te serveri kur klienti nuk i dërgon' },
          { type: 'fix', text: 'Grafiku i gjinisë te Analitika tregonte zero edhe kur fusha ishte e mbushur' },
          { type: 'security', text: 'Vlerësimet ishin të shkruajtshme nga çdo përdorues i kyçur — tani kërkojnë privilegj dhe kufizohen te vartësit e drejtpërdrejtë' },
        ],
      },
    ],
  },
  {
    version: 'v2026.08',
    label: 'Gusht 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Kërkesat dhe Aprovimet — një qendër e vetme për të gjitha kërkesat (pushime, korrigjime prezence, kërkesa të përgjithshme) me pamje Tabelë dhe Kanban' },
          { type: 'new', text: 'Kërkesë e përgjithshme — lloj i ri free-form (kategori · titull · përshkrim) me rrjedhë aprovimi' },
          { type: 'new', text: 'Aprovim hierarkik në 3 etapa për Karrierën & Kompensimin: Mbikëqyrës → HR → Menaxhment, me arsyetim të detyrueshëm në çdo etapë' },
          { type: 'new', text: 'Raport i kërkesave me eksport profesional në Excel (një fletë) dhe PDF — përmbledhje, sipas llojit/statusit dhe detajet' },
          { type: 'new', text: 'Aplikimi për konkurse në dy hapa — së pari detajet e konkursit, pastaj formulari; plus fusha "Rekomanduar nga" dhe deklarata e pëlqimit për ruajtjen e të dhënave' },
          { type: 'new', text: 'Email konfirmimi për aplikuesin — me përmbledhjen e aplikimit, dokumentet e ngarkuara dhe pëlqimin e pranuar' },
          { type: 'new', text: 'Imazh/banner te konkursi — ngarkohet gjatë krijimit dhe shfaqet te faqja publike e aplikimit' },
          { type: 'new', text: 'Butona "Shpërndaje" te faqja e aplikimit — Facebook, LinkedIn, WhatsApp dhe kopjimi i linkut' },
          { type: 'new', text: 'Widget mbështetjeje me minimizim dhe regjistrim ekrani — mund ta minimizosh dritaren ndërsa regjistrimi vazhdon' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Qendra e aprovimeve — dizajn tabelar kompakt, filtra (lloji + interval date me muajin aktual si default), renditje sipas kolonave dhe veprime të shpejta aprovo/refuzo' },
          { type: 'improve', text: '"Ndryshimet e punësimit" u riemërtua në "Karriera & Kompensimi"; pozita zgjidhet nga lista (jo tekst i lirë)' },
          { type: 'improve', text: 'Moduli "Qendra e Aprovimeve" u riemërtua në "Kërkesat dhe Aprovimet"' },
          { type: 'improve', text: 'Formulari publik i aplikimit më kompakt — më pak scroll' },
          { type: 'improve', text: 'Widget-i i mbështetjes u ridizajnua me ngjyrat e brand-it dhe ikonë të re bisede; butoni i ndihmës/turit në header u bë i veçantë' },
          { type: 'fix', text: 'Njoftimi i versioneve shfaqet vetëm një herë për version (jo në çdo hyrje)' },
        ],
      },
    ],
  },
  {
    version: 'v2026.07',
    label: 'Korrik 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Regjistrim i punëtorit me një hap — një formë e vetme krijon punëtorin, kontratën, qasjen në sistem dhe caktimin në projekt me një "Ruaj"' },
          { type: 'new', text: 'Regjistrimi i organizuar në 3 taba (Të dhëna bazike · Punësimi & Kontrata · Dokumente & Qasje) për më pak scroll' },
          { type: 'new', text: 'Qasje në sistem gjatë regjistrimit — krijim llogarie + caktim roli + ftesë me email' },
          { type: 'new', text: 'Anëtarët e sigurimit familjar — listë e personave të mbuluar; shuma ndahet automatikisht te anëtarët ose mblidhet si total' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Regjistrimi përfshin të gjitha fushat: ATK, sigurimi shëndetësor, leja e punës, banka, projektet dhe ndarja' },
          { type: 'improve', text: 'Kontrata dhe caktimi në projekt krijohen inline gjatë regjistrimit (pa hapa të veçantë)' },
          { type: 'improve', text: 'Faqja e regjistrimit më kompakte — koka dhe veprimet (Kthehu/Ruaj) në një rresht' },
          { type: 'fix', text: 'Titulli i faqes së regjistrimit nuk përsëritet më dy herë' },
        ],
      },
    ],
  },
  {
    version: 'v2026.06',
    label: 'Qershor 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Plani i Punës (FTE) — ndarja e orëve sipas projektit: një punëtor mund të punojë në disa projekte brenda të njëjtit orar' },
          { type: 'new', text: 'Caktimi i orarit — zgjedhje departamenti + segmente projektesh me interval kohor (nga–deri)' },
          { type: 'new', text: 'Njoftim me email kur caktohet/ndryshohet orari — te punëtori, udhëheqësi i projektit dhe HR' },
          { type: 'new', text: 'Raporti FTE — atribuim i orëve të punuara/planifikuara sipas projektit' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Caktimi i orarit — panel kompakt me bilanc orësh (orari vs. i ndarë) dhe ndarje automatike të segmenteve' },
          { type: 'improve', text: 'Rregullat e orëve — pauza e paguar reflektohet tani në orët e raportit' },
          { type: 'fix', text: 'Plani i Punës — ditët e pushimit shfaqen si "Pushim" (jo "Prezent")' },
          { type: 'fix', text: 'Plani i Punës — shigjetat e muajit funksionojnë në pamjen Ditore/Javore' },
          { type: 'fix', text: 'Plani i Punës — kolona "Punëtorë" me numër të saktë (zëvendëson "Total FTE")' },
          { type: 'fix', text: 'Cilësimet e kompanisë — korrigjim i ruajtjes së cilësimeve (SMTP)' },
          { type: 'security', text: 'Caktimi i orarit — ruhet në mënyrë transaksionale (pa gjendje të pjesshme)' },
        ],
      },
    ],
  },
  {
    version: 'v2026.03',
    label: 'Mars 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Attendance Dashboard — statistika ditore: prezencë, mungesa, vonesa, overtime' },
          { type: 'new', text: 'Attendance Summary Report — raport i konsoliduar me filtra periudhë / departament' },
          { type: 'new', text: 'Schedule Compliance Report — score % pajtueshmërie orar zyrtar vs. orar real' },
          { type: 'new', text: 'Monthly Work Hours Report — orët totale mujore krahasuar me planin' },
          { type: 'new', text: 'Work Schedule Matrix — matricë mujore individuale me ngjyrime sipas statusit' },
          { type: 'new', text: 'Attendance Adjustment — korrigjim manual hyrje/dalje me log auditimi' },
          { type: 'new', text: 'Shift Planning Templates — menaxhim turnesh nga cilësimet e kompanisë' },
          { type: 'new', text: 'Organigrami — pamje hierarkike vizuale e strukturës organizative' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Overview — ridesenjim i plotë: KPI kartela, brezar prezence live, sinjalizime me nivel rëndësie' },
          { type: 'improve', text: 'Navigimi — menuja anësore në 9 grupe tematike (Stafi, Prezenca, Financa…)' },
          { type: 'improve', text: 'Prezenca Live — 3× më shpejt, avatar punonjësi, grupim sipas departamentit' },
          { type: 'improve', text: 'Raportet — 4 kategori: Menaxhimi · ATK & Tatimet · Inspektorati · Pajtueshmëria' },
          { type: 'fix', text: 'Bilanci pushimeve — defekt me shumë kërkesa aktive në muaj të ndryshëm' },
          { type: 'fix', text: 'Eksport PDF — karakteret shqipe ë/ç nuk renderoheshin saktë' },
          { type: 'fix', text: 'Zonat kohore — check-in/out normalizohen në UTC+1 (CET)' },
        ],
      },
    ],
  },
  {
    version: 'v2026.02',
    label: 'Shkurt 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Task Management — bordi Kanban, 5 statuse, prioritete, caktim punonjësi' },
          { type: 'new', text: 'Time Tracking — kronometër integruar, hyrje manuale, lidhje projekt/aktivitet' },
          { type: 'new', text: 'Projektet & Klientët — buxhet, datë fillimi/mbarimi, status, lidhje klient' },
          { type: 'new', text: 'Interviews — planifikim me status të detajuar dhe shënime' },
          { type: 'new', text: 'Onboarding — lista kontrolli me template-detyra të personalizueshme' },
          { type: 'new', text: 'Bonuset & Rimbursimet — regjistrimi individual me status miratime' },
          { type: 'new', text: 'Knowledge Base — baza dijes me artikuj, kategori, akses për të gjithë' },
          { type: 'new', text: 'Politikat & Procedurat — bibliotekë HR e versionuar sipas departamentit' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Punëtorët — kolona "Leje biznesi", filtrim aktiv/joaktiv, kartë individuale' },
          { type: 'improve', text: 'Kontratat — dërgim email direkt nga lista + preview PDF' },
          { type: 'improve', text: 'Pagat — eksport XLSX me formatim bankar (bruto/neto/tatim)' },
          { type: 'security', text: 'Autentikimi — token invalidohet pas 24h inaktiviteti' },
          { type: 'fix', text: 'Filtri degë + departament nuk kthente rezultate kur të dy ishin aktive' },
        ],
      },
    ],
  },
  {
    version: 'v2026.01',
    label: 'Janar 2026',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'Work Schedules — orare me lloje turnesh, ditë aktive dhe caktim punonjësi' },
          { type: 'new', text: 'Hybrid & Remote Work — regjistrim ditëve punë nga shtëpia me shënime' },
          { type: 'new', text: 'Rekrutimi — Job Postings, Aplikimet dhe Funnel kandidatësh' },
          { type: 'new', text: 'Trainings — sesione, pjesëmarrës, statistika dhe filtra' },
          { type: 'new', text: 'Documents Registry — llojet dokumentesh me rikujtues skadence' },
          { type: 'new', text: 'Leave Calendar — pamje vizuale pushimesh me ngjyrime sipas llojit' },
          { type: 'new', text: 'Payroll Report — bruto/neto/tatim/kontribute sipas muajit' },
          { type: 'new', text: 'Employee Detail Report — prezencë + pushime + pagë + kontratë' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Njoftimet — badge, dropdown dhe nivel serioziteti me ngjyra' },
          { type: 'improve', text: 'Compliance Score — shpërndarje sipas kategorisë, update çdo 24h' },
          { type: 'improve', text: 'Audit Log — filtrim sipas llojit, datës, perdoruesit + eksport CSV' },
          { type: 'improve', text: 'Raportet ATK TM1–TM4 — format i ri sipas kërkesave 2026' },
          { type: 'fix', text: 'KBPK — nuk merrte parasysh punonjësit me shumë kontrata aktive' },
        ],
      },
    ],
  },
  {
    version: 'v2025.12',
    label: 'Dhjetor 2025',
    sections: [
      {
        title: 'Veçori të reja',
        entries: [
          { type: 'new', text: 'QR Check-in — skanim QR personal për regjistrim automatik prezence' },
          { type: 'new', text: 'Kiosk Mode — ekran i dedikuar me konfirmim vizual në kohë reale' },
          { type: 'new', text: 'Kiosk Electron App — desktop app me autostart dhe kiosk-lock' },
          { type: 'new', text: 'Vërejtjet Disiplinore — verbale/me shkrim/finale me nënshkrim dixhital' },
          { type: 'new', text: 'Worker Evaluation Report — skor prezencë + detyra + orë pune' },
          { type: 'new', text: 'HR Spend Report — kostot HR sipas muajit dhe departamentit' },
          { type: 'new', text: 'Turnover Report — norma mujore qarkullimi me krahasim vjetor' },
        ],
      },
      {
        title: 'Përmirësime & Korrigjime',
        entries: [
          { type: 'improve', text: 'Prezenca Live — ridesenjim: avatar, orë check-in, kohëzgjatja aktive' },
          { type: 'improve', text: 'Template Editor — variabla dinamike, editor teksti, preview PDF' },
          { type: 'security', text: 'Rate limiting — max 100 kërkesa/min per IP në të gjitha endpoints' },
          { type: 'fix', text: 'ATK TM3 — të dhëna të gabuara për muajin Dhjetor gjatë kalimit vjetor' },
        ],
      },
    ],
  },
];

/**
 * Versioni i tanishëm = i pari te lista.
 *
 * Më parë ishte një varg i shkruar me dorë që duhej të përputhej me
 * `package.json` dhe me hyrjen e parë të changelog-ut. Tre vende, dy mundësi
 * për të rrëshqitur — dhe të dyja rrëshqitën më 11 shtator 2026.
 */
export const CURRENT_VERSION = String(RELEASES[0]?.version || '').replace(/^v/, '');

/** I fundit është i pari; asnjë flamur nuk lëviz me dorë. */
export const isLatest = (release) => release === RELEASES[0];
